export default {
  controls: [
    {
      title: 'controls.folding_of_middle_siderails',
      icon: 'icon-postranice',
      animation: 'folding_of_foot_siderails',
      autoHideLabel: true,
      checkTransferMode: true,
      toggle: true
    },
    {
      title: 'controls.folding_of_head_siderails',
      icon: 'icon-head-siderails',
      animation: 'folding_of_head_siderails',
      autoHideLabel: true,
      toggle: true
    },
    {
      title: 'controls.mobilift',
      icon: 'icon-mobilift',
      animation: 'mobi_lift_handle',
      autoHideLabel: true,
      toggle: true
    }
  ],
  solutions: [
    {
      title: 'solutions.improving_pulmonary_outcomes',
      style: 'video_thumbnails',
      image: 'solutions--improving_pulmonary_outcomes.png',
      explanation: 'improving_pulmonary_outcomes'
    },
    {
      title: 'solutions.moving_immobile_patient',
      style: 'video_thumbnails',
      image: 'solutions--moving_immobile_patient.png',
      explanation: 'moving_immobile_patient'
    },
    {
      title: 'solutions.easier_patient_transfer',
      style: 'video_thumbnails',
      image: 'solutions--easier_patient_transfer.png',
      explanation: 'easier_patient_transfer'
    },
    {
      title: 'solutions.safe_patient_handling',
      style: 'video_thumbnails',
      image: 'solutions--safe_patient_handling.png',
      explanation: 'safe_patient_handling'
    },
    {
      title: 'solutions.mobilization_patient_early',
      style: 'video_thumbnails',
      image: 'solutions--mobilization_patient_early.png',
      explanation: 'mobilizing_patient_early'
    }
  ],
  keyFeatures: [
    {
      title: 'key_features.frame_based_lateral_tilt',
      style: 'thumbnails',
      image: 'key_features--frame_based_lateral_tilt.jpg',
      explanation: 'frame_based_lateral_tilt',
    },
    {
      title: 'key_features.mobilization',
      style: 'thumbnails',
      image: 'key_features--mobilization.jpg',
      explanation: 'mobilization',
      camera: {
        orbit: '-0.45rad 1.286rad 40%',
        target: '0 44m 0'
      }
    },
    {
      title: 'key_features.safety',
      style: 'thumbnails',
      image: 'key_features--safety.jpg',
      explanation: 'safety',
    },
    {
      title: 'key_features.controls',
      style: 'thumbnails',
      image: 'key_features--controls.jpg',
      explanation: 'controls',
    },
    {
      title: 'key_features.comfort',
      style: 'thumbnails',
      image: 'key_features--comfort.jpg',
      explanation: 'comfort',
    },
    {
      title: 'key_features.opticare_x',
      style: 'thumbnails',
      image: 'key_features--opticare_x.jpg',
      explanation: 'opticare_x',
    },
    {
      title: 'key_features.accessories',
      style: 'thumbnails',
      image: 'key_features--accessories.jpg',
      explanation: 'accessories',
    }
  ],
  modifications: [
    {
      title: 'modifications.mattress',
      icon: 'icon-mattress',
      options: {
        style: 'thumbnails',
        default: 0,
        items: [
          {
            title: 'modifications.mattress.with_mattress',
            image: 'modifications--with_mattras.jpg',
            modelParts: [
              {
                name: 'matrace_geoShape',
                visible: true
              },
              {
                name: 'matrace_geoShape_1',
                visible: true
              }
            ]
          },
          {
            title: 'modifications.mattress.without_mattress',
            image: 'modifications--without_mattras.jpg',
            modelParts: [
              {
                name: 'matrace_geoShape',
                visible: false
              },
              {
                name: 'matrace_geoShape_1',
                visible: false
              }
            ]
          }
        ]
      }
    }
  ]
}